export class PagingOptions {
  public isEnabled: boolean;
  public step: number;

  constructor(step?: number) {
    this.isEnabled = step !== undefined;
    this.step = step || 25;
  }
}
